import Main from './Main'
import Lista from './components/OperadorDeEmpilhadeiraLista'
import Novo from './components/NovoOperadorDeEmpilhadeira'

export default [
  {
    path: 'operador-empilhadeira',
    name: 'policiacivil.processo.operador-empilhadeira',
    component: Main,
    redirect: { name: 'policiacivil.processo.operador-empilhadeira.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.operador-empilhadeira.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.operador-empilhadeira.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.operador-empilhadeira.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/operador-empilhadeira/routes.js